var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 572.64001 572",
    width: 572.64001,
    height: 572,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill-rule:evenodd;}"))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 544.17,27.84 C 525.82,9.49 503.67,0 477.1,0 H 95.55 C 68.98,0 46.2,9.49 27.85,27.84 9.5,46.19 0,68.97 0,95.54 v 381.55 c 0,25.94 9.5,48.72 27.85,67.07 C 46.2,562.51 68.98,572 95.55,572 H 477.1 c 26.57,0 48.72,-9.49 67.07,-27.84 19,-18.35 28.47,-41.13 28.47,-67.07 V 95.54 c 0,-26.54 -9.49,-49.35 -28.47,-67.7 z M 92.39,477.09 H 47.49 V 286 h 44.9 z M 464.49,286 h 41.76 l -38,38.6 h -31 z M 180.34,480.25 c -14.55,0 -26.58,-4.43 -34.8,-13.28 -8.23,-8.23 -12,-22.78 -12,-42.4 V 367 h -20.27 v -32.9 h 20.22 V 286 h 43 v 48.09 H 203.7 V 367 h -27.16 v 50.62 c 0,9.49 1.27,15.82 3.8,19.62 q 4.74,7.59 15.18,7.59 c 4.43,0 7,-0.63 8.23,-1.9 l 0.63,33.54 c -6.96,2.53 -14.55,3.78 -24.04,3.78 z m 175.9,-3.16 H 315.75 V 461.9 h -1.26 c -10.12,12 -24.68,18.35 -44.29,18.35 q -21.84,0 -36.07,-13.28 c -8.22,-8.23 -12.65,-18.36 -12.65,-29.74 0,-18.35 8.22,-32.27 24,-41.77 15.19,-9.49 37.33,-13.91 66.44,-13.91 v -1.27 c 0,-13.29 -9.49,-19.62 -29.11,-19.62 -15.82,0 -29.74,3.8 -42.39,11.39 l -8.23,-27.84 c 15.19,-9.49 34.8,-13.92 58.22,-13.92 22.77,0 39.86,6.33 51.25,18.35 9.49,10.76 14.55,25.31 14.55,44.29 z m 168.31,0 h -39.23 v -22.78 h -0.63 c -10.13,17.08 -26.58,25.94 -48.72,25.94 -15.82,0 -28.48,-4.43 -38,-13.92 -10.75,-10.75 -16.45,-27.21 -16.45,-49.35 v -82.89 h 44.29 v 75.29 c 0,23.42 8.86,35.44 25.95,35.44 13.28,0 22.14,-6.33 27.2,-18.35 a 29.08,29.08 0 0 0 1.27,-8.86 v -83.52 h 44.29 z",
    id: "path6",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 313.21,409.38 v 15.19 l -0.63,8.23 a 24.77,24.77 0 0 1 -10.76,13.28 c -5.06,4.43 -11.38,6.33 -18.34,6.33 q -20.9,0 -20.88,-19 c 0,-17.06 17.08,-24.66 50.61,-24.03 z",
    id: "path8",
    style: {
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItau);
export default __webpack_public_path__ + "static/media/itau.4c97752e5cd11893576cbd043254055e.svg";
export { ForwardRef as ReactComponent };